import {useLazyQuery} from '@apollo/client/react';
import {extractGqlData} from '@coolcolduk/ui-apollo-client';
import {Prompt} from '@cp/model';
import {GET_PDF_SYSTEM_PROMPT} from '../sharedQueries';

export function useGetPdfSystemPrompt() {
  const [getPdfSystemPromptQuery, {loading, error}] = useLazyQuery<
    {getPdfSystemPrompt: Prompt},
    {additionalInfo?: string}
  >(GET_PDF_SYSTEM_PROMPT);

  const getPdfSystemPrompt = async (additionalInfo?: string) => {
    const result = await getPdfSystemPromptQuery({variables: {additionalInfo: additionalInfo || undefined}});
    return extractGqlData(result).getPdfSystemPrompt;
  };

  return {
    getPdfSystemPrompt,
    loading,
    error,
  };
}
